<!-- // 阻抗表 -->
<template>
  <div class="impedance-table__table">
    <el-table
      border
      class="impedance-table"
      :data="list"
      style="width: 100%"
    >
      <!-- 序号 -->
      <el-table-column type="index" :label="LANG.seq.en" width="50"></el-table-column>
      <!-- 要求阻抗 (ohm) -->
      <el-table-column prop="demand" :label="LANG.demand.en" width="110"></el-table-column>
      <!-- 阻抗层 -->
      <el-table-column prop="layer" :label="LANG.impLayer.en" width="70"></el-table-column>
      <!-- 阻抗模式 -->
      <el-table-column prop="mode_cn" :label="LANG.modeCn.en"></el-table-column>
      <!-- 原始线宽 -->
      <el-table-column prop="original_line_width" :label="LANG.originalLineWidth.en"></el-table-column>
      <!-- 原始线距 -->
      <el-table-column prop="original_line_space" :label="LANG.originalLineSpace.en"></el-table-column>
      <!-- 原到铜间距 -->
      <el-table-column prop="original_copper_space" :label="LANG.originalCopperSpace.en" width="110"></el-table-column>
      <!-- 上参考层 -->
      <el-table-column prop="top" :label="LANG.top.en" width="70"></el-table-column>
      <!-- 下参考层 -->
      <el-table-column prop="bot" :label="LANG.bot.en" width="70"></el-table-column>
      <!-- 线宽 -->
      <el-table-column
        prop="line_width"
        :label="LANG.lineWidth.en"
      >
        <template slot-scope="scope">
          <text-tip 
            width="350px" 
            :content="getTips(scope.row, 'line_width')" 
            :disabled="handleColor(scope.row, 'line_width') !== 1"
          >
            <div 
              slot="reference" 
              :class="['default', getColorClass(handleColor(scope.row, 'line_width'))]"
            >
              {{ scope.row.line_width }}
            </div>
          </text-tip>
        </template>
      </el-table-column>
      <!-- 线距 -->
      <el-table-column
        prop="line_space"
        :label="LANG.lineSpace.en"
      >
        <template slot-scope="scope">
          <text-tip 
            width="350px" 
            :content="getTips(scope.row, 'line_space')" 
            :disabled="handleColor(scope.row, 'line_space') !== 1"
          >
            <div 
              slot="reference" 
              :class="['default', getColorClass(handleColor(scope.row, 'line_space'))]"
            >
              {{ scope.row.line_space }}
            </div>
          </text-tip>
        </template>
      </el-table-column>
      <!-- 到铜距离 -->
      <el-table-column
        prop="copper_space"
        :label="LANG.copperSpace.en"
      >
        <template slot-scope="scope">
          <text-tip 
            width="350px" 
            :content="getTips(scope.row, 'copper_space')" 
            :disabled="handleColor(scope.row, 'copper_space') !== 1"
          >
            <div 
              slot="reference" 
              :class="['default', getColorClass(handleColor(scope.row, 'copper_space'))]"
            >
              {{ scope.row.copper_space }}
            </div>
          </text-tip>
        </template>
      </el-table-column>
      <!-- 计算结果 -->
      <el-table-column
        prop="result"
        :label="LANG.result.en"
      >
        <template slot-scope="scope">
          <text-tip 
            width="350px" 
            :content="getTips(scope.row, 'result')" 
            :disabled="handleColor(scope.row, 'result') !== 1"
          >
            <div 
              slot="reference" 
              :class="['default', getColorClass(handleColor(scope.row, 'result'))]"
            >
              {{ scope.row.result }}
            </div>
          </text-tip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { LANG } from './lang'
import TextTip from './text-tip.vue'

export default {
  components: {
    TextTip
  },
  
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      LANG
    }
  },

  methods: {
    // 线宽、线距、到铜距离、计算结果背景颜色：0-默认 1-标红 2-标绿 3-字体标红
    handleColor(row, prop) {
      const value = row[prop];
      const limit = { line_width: 3, line_space: 3.8, copper_space: 4 }[prop];
      // 判断 线宽、线距、到铜距离 背景颜色是否需要标红(value === '' || value == 0  || value < limit 时标红)
      let color = 0 //= !value || (limit && value !== '/' && Number(value) < limit) ? 1 : row[`${prop}_color`] || 0;
      if (!value) {
        color = 1
      } else {
        color = limit && value !== '/' && Number(value) < limit ? 3 : row[`${prop}_color`] || 0;

        if (prop == 'line_width') {
          color = value == row.original_line_width ? 0 : 3
        }

        if (prop == 'result') {
          color =  3
        }
      }
      
      return color;
    },
    
    getColorClass(color) {
      const colorMap = { 1: 'red', 2: 'green', 3: 'red_font' };
      return colorMap[color] || '';
    },
    
    getTips(row, prop) {
      if (!row[prop]) {
        return LANG['当前无法计算出结果'].en;
      }
      
      const tips = {
        line_width: LANG['线宽小于3mil'].en,
        line_space: LANG['线距小于3.8mil'].en,
        copper_space: LANG['到铜距离小于4mil'].en,
        result: LANG['计算结果与阻抗值相差±2ohm'].en
      };
      
      return tips[prop];
    }
  }
}
</script>